import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  FormControl,
  Stack,
  Typography,
  InputAdornment,
  Input,
  Select,
  MenuItem,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

import QuickStartErrorText from '../common/errorText';

interface CountryObject {
  code: string;
  name: string;
}

interface OperationalRegionTextFieldProps {
  setValue: (value: string) => void;
  verified: boolean;
  setVerified: (value: boolean) => void;
  error: string;
  list: CountryObject[];
  selected: string;
  isLoading: boolean;
  fielderror: string;
}

const OperationalRegionTextField = ({
  setValue,
  verified,
  setVerified,
  error,
  list,
  selected,
  isLoading,
  fielderror,
}: OperationalRegionTextFieldProps) => {
  return (
    <Stack flexGrow={1} gap={0.5}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom: '12px',
        }}
      >
        <FormattedMessage defaultMessage='Headquarters' />
      </Typography>
      {list.length > 0 ? (
        <Stack
          direction='row'
          alignItems='center'
          gap={0.5}
          sx={{
            border: '1px solid #D1D1D1',
            borderRadius: '6px',
            paddingX: '16px',
            '&:focus-within': {
              border: '1px solid #000000',
            },
            ...(selected.length > 0 && {
              backgroundColor: 'white!important',
              border: '1px solid black',
              '&:hover': {
                backgroundColor: 'white',
              },
            }),
          }}
        >
          <FormControl
            variant='standard'
            fullWidth
            sx={{
              width: '100%',
              '& .MuiFormLabel-root': {
                fontFamily: 'Schibsted Grotesk',
                fontSize: '16px',
                fontWeight: 400,
                textAlign: 'left',
                color: '#000000',
              },
              '& .MuiSelect-select': {
                paddingTop: '12px!important',
              },
              '& .MuiInput-input:focus': {
                backgroundColor: 'white',
              },
            }}
          >
            <Select
              labelId='assignee-select-label'
              IconComponent={() => <></>}
              disabled={isLoading || error !== undefined}
              sx={{
                padding: '6px 0px',
                backgroundColor: 'transparent',
                fontSize: '16px!important',
              }}
              disableUnderline={true}
              value={selected}
              onChange={(e) => setValue(e?.target.value)}
            >
              {Array.isArray(list) &&
                list?.length >= 0 &&
                list?.map((item, key) => (
                  <MenuItem key={key} value={item?.code}>
                    <Typography
                      sx={{
                        fontFamily: 'Schibsted Grotesk',
                        fontSize: '16px!important',
                        color: 'black',
                        fontweight: 400,
                        lineHeight: '17px',
                        letterspacing: '0em',
                        textalign: 'left',
                      }}
                      variant='body2'
                      className='role-menuitem'
                    >
                      {item?.name}
                    </Typography>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {verified ? (
            <CheckCircleIcon
              sx={{ color: '#00CECF', cursor: 'pointer' }}
              onClick={() => setVerified(false)}
            />
          ) : (
            <CheckCircleOutlineIcon
              sx={{ color: '#878787', cursor: 'pointer' }}
              onClick={() => setVerified(true)}
            />
          )}
        </Stack>
      ) : (
        <Input
          id='headquarter'
          name='headquarter'
          disableUnderline
          fullWidth
          sx={{
            border: '1px solid #D1D1D1',
            borderRadius: '6px',
            padding: '10px 16px',
            '& .MuiInputBase-input': {
              fontFamily: 'Schibsted Grotesk, sans-serif',
              fontSize: '16px',
              fontWeight: 500,
              color: '#181818',
              lineHeight: '125%',
            },
            '&:focus-within': {
              border: '1px solid #000000',
            },
            ...(selected.length > 0 && {
              backgroundColor: 'white!important',
              border: '1px solid black',
              '&:hover': {
                backgroundColor: 'white',
              },
            }),
          }}
          endAdornment={
            <InputAdornment position='end'>
              {verified ? (
                <CheckCircleIcon
                  sx={{ color: '#00CECF', cursor: 'pointer' }}
                  onClick={() => setVerified(false)}
                />
              ) : (
                <CheckCircleOutlineIcon
                  sx={{ color: '#878787', cursor: 'pointer' }}
                  onClick={() => setVerified(true)}
                />
              )}
            </InputAdornment>
          }
          value={selected}
        />
      )}
      {fielderror !== '' && <QuickStartErrorText error={fielderror} />}
    </Stack>
  );
};

export default OperationalRegionTextField;
